export const getHasFilters = filters => {
  const hasFilters =
    (filters.tags && filters.tags.length > 0) ||
    (filters.funnelTag && filters.funnelTag.length > 0) ||
    filters.search ||
    filters.starred ||
    (filters.fromDate) ||
    (filters.toDate)
  return !!hasFilters
};